import { createElement, setText } from './dom';
import { setLabel } from './i18n';
import type { Account } from '../account/account';
import type { AccountState } from '../account/allauth';

/** The gateway's way to the account: "Sign in", or the address that is signed in. */
export function createAccountLauncher(
  parent: HTMLElement,
  account: Account,
  open: () => void
): () => void {
  const button = createElement('button', 'settings-launcher account-launcher', parent);
  button.type = 'button';
  button.setAttribute('aria-haspopup', 'dialog');
  button.setAttribute('aria-controls', 'account-dialog');
  setLabel(button, 'title', 'Account');
  const label = createElement('span', 'account-launcher-label', button);
  const draw = (state: AccountState): void => {
    if (state.kind === 'signedIn') setText(label, state.email);
    else setText(label, 'Sign in');
  };
  button.addEventListener('click', open);
  draw(account.state);
  const stop = account.onChange(draw);
  return () => {
    stop();
    button.remove();
  };
}
